import {
  UPDATE_CALENDAR_EVENT_STATUS,
  UPDATE_EVENT_STATUS,
  UPDATE_EVENT_STATUS_FAILED,
  REQUEST_STATUS_TRANSITION_LIST,
  REQUEST_STATUS_TRANSITION_LIST_SUCCEEDED,
  REQUEST_STATUS_TRANSITION_LIST_FAILED,
  READ_ALL_AVAILABLE_STATUSES,
  READ_ALL_AVAILABLE_STATUSES_SUCCEEDED,
  READ_ALL_AVAILABLE_STATUSES_FAILED,
} from "./types"

export const updateCalendarEventStatus = config => {
  return { type: UPDATE_CALENDAR_EVENT_STATUS, config }
}

export const updateStatus = config => {
  return { type: UPDATE_EVENT_STATUS, config }
}

export const updateStatusError = (action, error) => {
  return { type: UPDATE_EVENT_STATUS_FAILED, action, error }
}

export const requestTransitionList = config => {
  return { type: REQUEST_STATUS_TRANSITION_LIST, config }
}

export const requestTransitionListSuccess = (action, response) => {
  return { type: REQUEST_STATUS_TRANSITION_LIST_SUCCEEDED, action, response }
}

export const requestTransitionListError = (action, error) => {
  return { type: REQUEST_STATUS_TRANSITION_LIST_FAILED, action, error }
}

export const readAllStatuses = () => {
  return { type: READ_ALL_AVAILABLE_STATUSES }
}

export const readAllStatusesSuccess = (action, response) => {
  return { type: READ_ALL_AVAILABLE_STATUSES_SUCCEEDED, action, response }
}

export const readAllStatusesError = (action, error) => {
  return { type: READ_ALL_AVAILABLE_STATUSES_FAILED, action, error }
}
